<template>
    <user-opt-his 
        ref="list"
        header-text="ユーザー操作履歴"
        >
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2 p-2" @click="showIp = !showIp">
                    <ul class="list-group list-group-flush">
                        <li v-for="item in getListObj.data" :key="item.opt_id" class="list-group-item p-1 let-space-1">
                            <div class="d-flex">
                                <span class="text-truncate">
                                    <small>({{item.id}}){{item.name}}</small>
                                    <small v-if="item.sales_name">/{{item.sales_name}} </small>
                                </span>
                                <span class="flex-fill text-right">
                                    <small v-if="item.user_group == 'none'">
                                        <span v-if="item.cmp_group"> {{item.cmp_group}}(営業)</span>
                                        <span v-else>(個人)</span>
                                    </small>
                                    <small v-else> {{item.user_group}}(法人) </small>
                                </span>
                            </div>
                            <div>
                                <div class="text-right">
                                    <small><small class="text-muted">{{item.created_at | dformatm}}</small></small>
                                </div>
                            </div>
                            <div v-show="showIp" class="text-muted">
                                <hr class="my-2">
                                <div v-if="item.user_agent">
                                    <small>
                                        <div>{{item.user_agent}}</div>
                                    </small>
                                </div>
                                <div v-else class="text-center"><small>アクセス情報はありません</small></div>
                            </div>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </user-opt-his>
</template>

<script>
    import UserOptHis from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            UserOptHis
        },
        mounted () {
            this.$refs.list.loadListObj({
                url: 'setting.user.opt.his'
            })
        },
        data () {
            return {
                showIp: false
            }
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
    }
</script>
